export default __webpack_public_path__ + "static/SharpGrotesk-Bold-17c87a58709194f4c883859cf54e323e.otf";